/**
 * Derive plain text from TipTap JSON for emails, digests, and truncated previews.
 * Notes stay JSON in Firestore; plaintext is not persisted.
 */
export function tiptapJsonToPlainText(doc: unknown): string {
  if (typeof doc === "string") return doc
  if (!doc || typeof doc !== "object") return ""

  const parts: string[] = []
  walkTiptapNode(doc, parts)
  return parts.join("").replace(/[ \t]+\n/g, "\n").replace(/\n+$/g, "").trim()
}

/** Recursively collect text from a TipTap JSON node tree. */
function walkTiptapNode(node: unknown, parts: string[]) {
  if (!node || typeof node !== "object") return

  const next = node as {
    type?: string
    text?: string
    content?: unknown[]
  }

  if (typeof next.text === "string") {
    parts.push(next.text)
  }

  if (Array.isArray(next.content)) {
    for (const child of next.content) {
      walkTiptapNode(child, parts)
    }
  }

  if (
    next.type === "paragraph" ||
    next.type === "heading" ||
    next.type === "listItem" ||
    next.type === "hardBreak"
  ) {
    parts.push("\n")
  }
}
